import VueDragscroll from 'vue-dragscroll'

Vue.use(VueDragscroll)
